import React from "react";
import { FaGithub, FaExternalLinkAlt } from "react-icons/fa";

const PortfolioItem = (props) => {
  const { image, title, link, description } = props.portfolio;

  return (
    <div className="w-full lg:w-1/2 p-2 md:p-3" data-scroll-reveal>
      <a href={link} target="_blank" rel="noopener noreferrer" className="group h-full">
        <div className="relative rounded-2xl overflow-hidden h-full">
          {/* Glass base */}
          <div className="absolute inset-0 bg-white/70 backdrop-blur-md opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

          {/* Image with overlay */}
          <div className="relative h-48 overflow-hidden rounded-2xl border border-gray-200/50">
            <img
              src={image}
              alt={title}
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
            />

            {/* Gradient overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 via-gray-900/40 to-transparent group-hover:from-gray-900/90 transition-all duration-300" />

            {/* Accent line */}
            <div className="absolute top-0 left-0 w-1 h-16 bg-gradient-to-b from-green-400 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
          </div>

          {/* Content */}
          <div className="relative p-6 rounded-b-2xl bg-gradient-to-b from-white/60 to-white/40 backdrop-blur-sm border-b border-l border-r border-white/40">
            <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-2 group-hover:text-green-600 transition-colors">
              {title}
            </h3>
            <p className="text-sm text-gray-700 line-clamp-2 mb-4">
              {description}
            </p>

            {/* Action buttons */}
            <div className="flex items-center gap-3">
              <div className="flex items-center gap-2 px-3 py-2 rounded-lg bg-gradient-to-r from-green-100 to-emerald-100 border border-green-200 text-green-700 text-sm font-semibold group-hover:shadow-lg group-hover:shadow-green-400/30 transition-all">
                <FaGithub className="text-lg" />
                <span>View Code</span>
              </div>
              <FaExternalLinkAlt className="text-green-600 opacity-0 group-hover:opacity-100 transition-opacity group-hover:translate-x-1 duration-300" />
            </div>
          </div>
        </div>
      </a>
    </div>
  );
};

export default PortfolioItem;
